import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

/*
  - layout
*/
import Header from './layout/Header';
import Loading from './layout/Loading';

/*
  - page
*/
import Dashboard from './pages/Dashboard';
import Favorite from './pages/Favorite';
import Finance from './pages/Finance';
import Reserve from './pages/Reserve';
import Passenger from './pages/Passenger';
import Request from './pages/Request';
import User from './pages/User';
import Profile from './pages/Profile';

/*
    - api
*/
import getAPI from './api/get';

const App = () => {

  /*
    - defaultData
  */
  const [type, setType] = React.useState('');
  React.useEffect(() => {
    const fetchData = async () => {
      let userRegisterType = '';
      let userRegisterTypeParameters = {
        ctrl: 'UserProfile',
        method: 'GetUserRegisterTypes',
        query: ''
      }
      userRegisterType = await getAPI(userRegisterTypeParameters);
      if (userRegisterType.status === 200) {
        if (userRegisterType.data.some((obj) => (obj.registerType === 3))) {
          localStorage.setItem('type', 'B2B');
          document.title = 'B2B Dashbaord';
          setType('B2B');
        } else {
          localStorage.setItem('type', 'B2C');
          document.title = 'B2C Dashboard';
          setType('B2C');
        }
      }
    }
    fetchData();
  }, []);

  /*
    - reloadLayout
  */
  const [reloadHeader, setReloadHeader] = React.useState('');
  const reloadHeaderProps = (reloadHeaderProps) => {
    setReloadHeader(reloadHeaderProps);
  }

  return (
    <React.Fragment>
      <Router>
        {type === '' &&
          <Loading />
        }
        <Header props={reloadHeader} />
        <Routes>
          <Route path='/dashboard/:paymentStatus' element={<Dashboard reloadHeaderProps={reloadHeaderProps} />} />
          <Route path='/dashboard/' element={<Dashboard reloadHeaderProps={reloadHeaderProps} />} />
          <Route path='/favorite' element={<Favorite />} />
          <Route path='/finance/report' element={<Finance />} />
          <Route path='/finance/settlement' element={<Finance />} />
          <Route path='/finance/bank' element={<Finance />} />
          <Route path='/passenger' element={<Passenger />} />
          <Route path='/request' element={<Request />} />
          <Route path='/request/:history' element={<Request />} />
          <Route path='/reserve' element={<Reserve />} />
          <Route path='/user/sub-organization' element={<User />} />
          <Route path='/user/member' element={<User />} />
          <Route path='/profile/base-info' element={<Profile />} />
          <Route path='/profile/boss-info' element={<Profile />} />
          <Route path='/profile/officer-info' element={<Profile />} />
          <Route path='/profile/upload-license' element={<Profile />} />
          <Route path='/profile/change-pass' element={<Profile />} />
          <Route path='/user/passenger' element={<User />} />
          <Route path='/user/agent' element={<User />} />
        </Routes>
      </Router>
    </React.Fragment>
  );

}

export default App;
